/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React, { memo } from 'react'
import { DeleteOutlined } from '@ant-design/icons'
import colors from '@sportninja/common/constants/appColors'
import { isCanlan } from '@sportninja/common/utils/customer-name'
import Text from '../ts-components/Text'
import { deleteCommentButtonStyles } from './FeedItem.styles'

/**
 * Delete comment button component
 * Renders a button with delete icon and text for deleting comments
 */
const DeleteCommentButton = memo<React.ButtonHTMLAttributes<HTMLButtonElement>>(
  ({ ...props }) => {
    return (
      <button
        css={[
          deleteCommentButtonStyles,
          css`
            font-family: ${isCanlan
              ? 'Neue Plak Condensed, Arial, Helvetica, sans-serif !important;'
              : 'BarlowCondensed, Arial, Helvetica, sans-serif !important;'};
          `,
        ]}
        {...props}
      >
        <DeleteOutlined
          css={css`
            color: ${colors.ERROR_200};
          `}
        />
        <Text variant='paragraphMedium' weight='semiBold' color={colors.WHITE}>
          DELETE COMMENT
        </Text>
      </button>
    )
  }
)

DeleteCommentButton.displayName = 'DeleteCommentButton'

export default DeleteCommentButton
